<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请选择">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in list" :key="index"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "ReportedState",
    watch: {
      value: {
        immediate: true,
        handler: function(value) {
          this.data = value;
        }

      }
    },
    props: ["value"],
    data() {
      return {
        data: "",
        list: [
          {
            name: "上报中",
            value: "2"
          },
          {
            name: "未上报",
            value: "1"
          },
          {
            name: "上报失败",
            value: "4"
          }
        ]
      }
    },
    methods: {
      handleChange(value) {
        this.data = value;
        this.$emit("input", value)
      }
    }
  }
</script>

<style scoped>

</style>
